import React from 'react';
import PropTypes from 'prop-types';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import validationFormsStyle from 'assets/jss/material-dashboard-pro-react/views/validationFormsStyle';
// our components
import ReviewReportDetails from 'components/ReviewReport/Details';

const ScreenReviewReportDetails = props => {
  const { classes, match } = props;
  return (
    <div className={classes.container}>
      <ReviewReportDetails id={match.params.id} />
    </div>
  );
};

ScreenReviewReportDetails.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(validationFormsStyle)(ScreenReviewReportDetails);
